import { render, staticRenderFns } from "./DispensationAdd.vue?vue&type=template&id=72996e74&"
import script from "./DispensationAdd.vue?vue&type=script&lang=js&"
export * from "./DispensationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports